var path = 'templates/transcription/content_status.html';
var html = "<div class=content-status> <div class=content-count> <select ng-model=contentIndex ng-change=changeIndex() style=width:50px> <option ng-repeat=\"t in transcriptions\" value={{$index+1}}> {{$index+1}}（{{t.getCurrentState().label}}） </option> </select> /{{book.size}} {{'transcription.images' | translate}} </div> <div class=current-status> <span class=md-secondary> {{transcription.getCurrentState().label}} <span ng-if=transcription.isFrozen()>（保護中）</span> <i ng-if=transcription.realtimeMode style=font-size:16px;vertical-align:middle class=material-icons title=リアルタイム編集中>watch_later</i> </span> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/transcription/content_status.html
// module id = 60
// module chunks = 0